/* eslint-disable react/prop-types */
import React from 'react';
import Select from 'react-select';

const ProvinceSelect = ({ formData, setFormData, Provinsi }) => {
  const provinceOptions = Provinsi.map((province) => ({
    value: province.name,
    label: province.name,
  }));

  const handleProvinceChange = (selectedOption) => {
    setFormData({
      ...formData,
      address: {
        ...formData.address,
        state: selectedOption ? selectedOption.value : '',
      },
    });
  };

  return (
    <Select
      options={provinceOptions}
      placeholder="Tulis untuk mencari provinsi"
      onChange={handleProvinceChange}
      value={provinceOptions.find((option) => option.value === formData.address.state)}
      isSearchable
    />
  );
};

export default ProvinceSelect;
